<template>
  <popup-form class="multi--loc" large v-bind="popupAttr" @back="onBack" @close="$emit('close')">
    <div slot="main" class="multi--loc__body">
      <span class="multi--loc__title">{{ $t('jobDetail.location') }}</span>
      <div class="multi--loc__section">
        <loc-list
          v-model="seletectedItems"
          class="multi--loc__list"
          :class="locationListClass"
          icon="arrow"
          is-single-selected
          :addresses="addresses"
        />
        <div class="multi--loc__map" :class="mapClass">
          <map-link :width="440" :height="696" :zoom="16" :lat="selectedLatitude" :lng="selectedLongitude" />
          <loc-item v-if="isMobile && selectedAddress" class="multi--loc__map-address" :address="selectedAddress" />
        </div>
      </div>
    </div>
  </popup-form>
</template>

<script>
import LocationItem from '../../list/location/locationItem'
import LocationList from '../../list/location/locationList'
import MapLink from '../../map/mapLink'
import PlatformMixin from '../../../mixins/platform'
import PopupForm from '../../popup/popupForm'

export default {
  components: {
    'loc-item': LocationItem,
    'loc-list': LocationList,
    'map-link': MapLink,
    'popup-form': PopupForm,
  },
  computed: {
    locationListClass() {
      return {
        'multi--loc__list-hidden': this.seletectedItems.length > 0,
      }
    },
    mapClass() {
      return {
        'multi--loc__map-visible': this.seletectedItems.length > 0,
      }
    },
    popupAttr() {
      return {
        showBack: this.isMobile,
        showClose: !this.isMobile,
      }
    },
    selectedAddress() {
      return this.seletectedItems[0]
    },
    selectedLatitude() {
      if (this.selectedAddress) {
        return this.selectedAddress.lat
      }
      return 0
    },
    selectedLongitude() {
      if (this.selectedAddress) {
        return this.selectedAddress.lng
      }
      return 0
    },
  },
  created() {
    // Pre-select the first address
    if (!this.isMobile) {
      this.seletectedItems.push(this.addresses[0])
    }
  },
  data() {
    return {
      seletectedItems: [],
    }
  },
  methods: {
    onBack() {
      if (this.seletectedItems.length > 0) {
        this.seletectedItems = []
      } else {
        this.$emit('close')
      }
    },
  },
  mixins: [PlatformMixin],
  props: {
    addresses: {
      default: () => [],
      type: Array,
    },
  },
}
</script>

<style lang="postcss" scoped>
.multi--loc__body {
  @apply flex flex-col w-full;
}
.multi--loc__title {
  @apply text-csub-title1 font-csub-title1 mb-3;
  @apply ml-2;
}
.multi--loc__section {
  @apply flex flex-row flex-grow min-h-0;
}
.multi--loc__list {
  @apply overflow-y-auto;
  flex: 1;
}
.multi--loc__map {
  @apply relative;
  flex: 1;
}

>>> .popup__main > * {
  @apply px-0;
}
>>> .popup-hdr {
  @apply m-0;
}

@screen mobile {
  .multi--loc {
    & >>> .loc-item__main {
      @apply shadow;
    }
  }
  .multi--loc__list-hidden {
    @apply hidden;
  }
  .multi--loc__map {
    @apply hidden;
  }
  .multi--loc__map-visible {
    @apply block;
  }
  .multi--loc__list {
    @apply px-2;
  }

  >>> .map-link {
    @apply rounded-none;
  }
  .multi--loc__map-address {
    @apply absolute;
    @apply bottom-0 left-0 right-0;
    @apply mx-2;
  }
}

@screen desktop {
  .multi--loc {
    & >>> .loc-item__main--active {
      @apply shadow;
    }
  }
  .multi--loc {
    & >>> .popup {
      width: 880px;
      max-height: 832px;
    }
  }
  .multi--loc__title {
    @apply text-ch3 font-ch3;
    @apply ml-9;
  }
  .multi--loc__section {
    @apply px-8;
  }
  .multi--loc__list {
    @apply mr-4;
    flex: 4;
  }
  .multi--loc__map {
    flex: 6;
  }
  >>> .popup-hdr {
    @apply px-4;
  }
}
</style>
